<div class="main-content">
  <div class="responsive-bg">
    <div class="sub-header d-flex align-items-center w-100" style="background-color: rgba(255, 255, 255, 0.349);">
      <div class="left-content d-flex align-items-center">
        <div class="page-icon pe-3">
          <i class="bi bi-speedometer2"></i>
        </div>
        <div class="title" style="color: black;">
          <span>Saledesk Dashboard</span>
        </div>
      </div>
      <div class="update-message-container">
        <!-- <div *ngIf="currentMessage" [@slideInOut]> -->
          <div *ngIf="currentMessage" [@fadeInOut]>
          <span class="update-message">{{ currentMessage }}</span>
        </div>
      </div>
    </div>
    <div class="module-bg">
      <div class="col-md-12 mx-auto">
        <div class="accountmodule h-100">
          <div class="row">
            <div class="col-md-3 mb-4" *ngFor="let module of moduleList; let i=index">
  <div [routerLink]="[module?.path]" class="module-card" (click)="updateModuleId(module?.ModuleID)">
    <img [src]="'assets/img/MODULE/' + (module?.ModuleFilePath || 'default.png')" 
         [alt]="module?.ModuleName || 'Module'" 
         class="images">
    <h5 class="module-name">{{ module?.ModuleName }}</h5>
    <p>{{ module?.Description }}</p>
  </div>
</div>

            <!-- <div class="col-md-3 mb-4">
              <div class="module-card">
                <a href="https://oneview.casaerp.in/authentication/login" target="_blank">
                  <img src="../../../assets/images/notification.png" alt="SaleDesk" class="images" style="border-radius: 50%;">
                </a>
                <h5 class="module-name">Notifications</h5>
                <p>Saledesk OTP's to approve & unapprove</p>
              </div>
            </div> -->
 
            <div class="col-md-3 mb-4">
              <div class="module-card">
                <a (click)="showAlert()">
                  <img src="../../../assets/images/notification.png" alt="SaleDesk" class="images" style="border-radius: 50%;">
                </a>
                <h5 class="module-name">Notifications</h5>
                <p>Saledesk OTP's to approve & unapprove</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
 
    <!-- Footer aligned to the right -->
    <footer class="footer">
      <span class="footer-content">
        Copyright © Saledesk 2025
        <img src="../../../assets/img/sconexsoft-Recovered.png" alt="Logo" class="footer-logo" />
      </span>
    </footer>
    
  </div>
</div>
 